import styled, { css } from 'styled-components';

import { CONTAINER_BREAKPOINTS, CONTAINER_MAX } from '@/constants/breakpoints';

import { AdsGridLength, DesktopCols } from './AdsList.types';

// Column-count ranges of the cards grid: 1 column on phones, 2 on small
// tablets, 3 on large tablets, 3 or 4 on desktop depending on the page.
const RANGE_QUERIES: Record<keyof AdsGridLength, string> = {
  mobile: `(max-width: ${CONTAINER_MAX.tablet})`,
  tablet: `(min-width: ${CONTAINER_BREAKPOINTS.tablet}) and (max-width: ${CONTAINER_MAX.tabletL})`,
  tabletL: `(min-width: ${CONTAINER_BREAKPOINTS.tabletL}) and (max-width: ${CONTAINER_MAX.desktop})`,
  desktop: `(min-width: ${CONTAINER_BREAKPOINTS.desktop})`
};

const renderLengthLimits = (length?: AdsGridLength) => {
  if (!length) return null;

  return Object.entries(length).map(([range, limit]) => {
    if (!limit) return null;

    return css`
      @media ${RANGE_QUERIES[range as keyof AdsGridLength]} {
        & > *:nth-child(n + ${limit + 1}) {
          display: none;
        }
      }
    `;
  });
};

export const ListWrapper = styled.div<{
  $desktopCols?: DesktopCols;
  $length?: AdsGridLength;
}>`
  width: 100%;
  height: fit-content;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  padding: 20px 0 0;

  & > * {
    min-width: 0;
  }

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: ${CONTAINER_BREAKPOINTS.tabletL}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: ${CONTAINER_BREAKPOINTS.desktop}) {
    grid-template-columns: repeat(
      ${({ $desktopCols }) => $desktopCols ?? 3},
      minmax(0, 1fr)
    );
  }

  ${({ $length }) => renderLengthLimits($length)}
`;
